import { Box, Button, MenuItem, TextField, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import "./FirstStage.css";
import * as Yup from "yup";
import { Formik } from "formik";
import FormInput from "../../../Components/atoms/FormInput/FormInput";
import TextFieldInput from "../../../Components/atoms/Inputs/TextField/TextFieldInput";
import { PhoneInput } from "react-international-phone";
import phone from "phone";
import "react-international-phone/style.css";
import TeamCard from "../../../Components/molecules/Cards/TeamCard/TeamCard";
import WhiteModal from "../../../Components/molecules/Modal/Modal";
import { PulseLoader } from "react-spinners";
import { arrayOfAcademies } from "../../../helpers/Arrays";
import { Images } from "../../../helpers/Images";
import CloseIcon from "@mui/icons-material/Close";
import { useNavigate } from "react-router-dom";

const PhaseOneOrganizationSchema = Yup.object().shape({
  admin_name: Yup.string().required("Admin Name required !!"),
  admin_email: Yup.string()
    .email("Invalid email !!")
    .required("Admin Email required !!"),
  referralSource: Yup.string().required("Choose an option !!"),
  organization_id: Yup.string().required("Organization required !!"),
  organization_name: Yup.string().when("organization_id", (organization_id) => {
    if (organization_id == -1) {
      return Yup.string().required("Organization Name required !!");
    }
  }),
  country: Yup.string().required("Branch Country required !!"),
  gov: Yup.string().required("Branch Governorate required !!"),
  address: Yup.string().required("Branch Street required !!"),
  password: Yup.string()
    .min(8, "Password is too short !!")
    .test(
      "isValidPass",
      "Password must contain at least 1 number, 1 uppercase, 1 lowercase, 1 special character !!",
      (value, context) => {
        const hasUpperCase = /[A-Z]/.test(value);
        const hasLowerCase = /[a-z]/.test(value);
        const hasNumber = /[0-9]/.test(value);
        const hasSymbol = /[!@#%&]/.test(value);
        let validConditions = 0;
        const numberOfMustBeValidConditions = 4;
        const conditions = [hasLowerCase, hasUpperCase, hasNumber, hasSymbol];
        conditions.forEach((condition) =>
          condition ? validConditions++ : null
        );
        if (validConditions >= numberOfMustBeValidConditions) {
          return true;
        }
        return false;
      }
    )
    .required("Password required !!"),
  confirmPassword: Yup.string()
    .min(8, "Password is too short !!")
    .oneOf([Yup.ref("password"), null], "Passwords must match")
    .required("Password required !!"),
});

const roles = [
  { name: "Team leader", id: 1 },
  { name: "Supervisor", id: 2 },
  { name: "Academy Owner", id: 3 },
  { name: "School organizer", id: 4 },
  { name: "Parents", id: 5 },
];

const FirstStageTemplate = ({
  newObject,
  setNewObject,
  setGoSave,
  confirmOpen,
  setConfirmOpen,
  feesOpen,
  setFeesOpen,
  setFinalSave,
  addLoading,
  countriesList,
  organizationsList,
  newObjectConfirm,
  setCountry,
  cities,
  FinalLoading,
  userType,
  handleType,
}) => {
  const navigate = useNavigate();
  const [Phone, setPhone] = useState("");
  const [PhoneError, setPhoneError] = useState(null);
  const [PhoneTouched, setPhoneTouched] = useState(false);
  const [PhoneOrg, setPhoneOrg] = useState("");
  const [PhoneOrgError, setPhoneOrgError] = useState(null);
  const [PhoneOrgTouched, setPhoneOrgTouched] = useState(false);
  // const [teams, setTeams] = useState([]);
  // const [teamsError, setTeamsError] = useState(null);

  useEffect(() => {
    if (
      !phone(Phone)?.isValid ||
      (Phone?.length < 13 && phone(Phone)?.countryCode == "+20")
    )
      setPhoneError("Valid Phone Number Required!!");
    else setPhoneError("");
  }, [Phone]);

  useEffect(() => {
    if (
      !phone(PhoneOrg)?.isValid ||
      (PhoneOrg?.length < 13 && phone(PhoneOrg)?.countryCode == "+20")
    )
      setPhoneOrgError("Valid Phone Number Required!!");
    else setPhoneOrgError("");
  }, [PhoneOrg]);

  return (
    <>
      {false ? (
        <>
          <Box
            sx={{
              width: "100%",
              padding: {
                xs: "70px 20px",
                sm: "70px 60px",
                lg: "70px 120px",
                xl: "150px 120px",
              },
              background: `linear-gradient(0deg, rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.5)), url(${Images.gold})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
              minHeight: "500px",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
            }}
          >
            <Typography
              variant={"h1"}
              sx={{
                textAlign: "center",
                fontSize: { xs: "35px", sm: "40px" },
                fontWeight: "500",
                color: "secondary.main",
              }}
            >
              Registration 2024
            </Typography>
            <Typography
              variant={"h1"}
              sx={{
                textAlign: "center",
                fontSize: { xs: "60px", sm: "70px" },
                fontWeight: "700",
                color: "secondary.main",
              }}
            >
              COMING SOON
            </Typography>
            <Typography
              sx={{
                textAlign: "center",
                fontSize: "20px",
                fontWeight: "400",
                color: "secondary.main",
                marginTop: "0px",
              }}
            >
              Are you ready to be the champion this year ?
            </Typography>
          </Box>
        </>
      ) : (
        <>
          <Box
            sx={{
              width: "100%",
              padding: { xs: "50px 20px", sm: "50px 60px", lg: "50px 120px" },
              maxWidth: "1500px",
              margin: "auto",
            }}
          >
            <Typography
              variant={"h1"}
              sx={{
                textAlign: "center",
                fontSize: { xs: "40px", sm: "55px" },
                fontWeight: "500",
                color: "primary.darker",
              }}
            >
              Register to International Robot Challenge System
            </Typography>
            <Typography
              sx={{
                textAlign: "center",
                fontSize: "18px",
                fontWeight: "400",
                color: "primary.darker",
                margin: "auto",
                marginTop: "20px",
                maxWidth: "800px",
              }}
            >
              Please complete the form below to create a new account in wedo
              challenge registration system. <br />
              Already registered?{" "}
              <a
                // href="https://registrationstaging.international-robotchallenge.org/login"
                href="https://registration.international-robotchallenge.org/login"
                target="_blank"
              >
                Log in to your account
              </a>
            </Typography>
            {/* <Box
              sx={{
                height: "3px",
                maxWidth: { xs: "100px", md: "250px" },
                width: "100%",
                backgroundColor: "primary.main",
                margin: "10px auto 50px auto",
              }}
            /> */}
            <Formik
              initialValues={{
                admin_name: "",
                admin_email: "",
                organization_id: "",
                organization_name: "",
                country: 42,
                gov: "",
                address: "",
                password: "",
                confirmPassword: "",
                referralSource: "",
              }}
              validationSchema={PhaseOneOrganizationSchema}
              onSubmit={(values) => {
                if (userType == "organization") {
                  if (!PhoneError && !PhoneOrgError) {
                    setNewObject({
                      admin: {
                        name: values?.admin_name,
                        email: values?.admin_email,
                        contactNumber: Phone,
                      },
                      referralSource: values?.referralSource,
                      type: "organization",
                      organization:
                        values?.organization_id == -1
                          ? {
                              new: true,
                              name: values?.organization_name,
                              branch: {
                                address: values?.address,
                                cityId: values?.gov,
                                contactNumber: PhoneOrg,
                              },
                            }
                          : {
                              new: false,
                              id: values?.organization_id,
                              branch: {
                                address: values?.address,
                                cityId: values?.gov,
                                contactNumber: PhoneOrg,
                              },
                            },
                      accountPassword: {
                        password: values?.password,
                        confirmPassword: values?.confirmPassword,
                      },
                    });
                    setGoSave(true);
                  }
                }
              }}
            >
              {({
                values,
                errors,
                touched,
                handleChange,
                handleBlur,
                handleSubmit,
              }) => (
                <form
                  className="FormContainer"
                  autoComplete="off"
                  onSubmit={handleSubmit}
                >
                  <div
                    className="FormContainerBox"
                    style={{
                      marginTop: "30px",
                    }}
                  >
                    <div>
                      <TextFieldInput
                        name="admin_name"
                        type="text"
                        placeholder={"Enter your name"}
                        className="Input"
                        label={"Admin Name"}
                        change={handleChange}
                        blur={handleBlur}
                        newValue={values.admin_name}
                      />
                      {errors.admin_name &&
                        touched.admin_name &&
                        errors.admin_name && (
                          <p className="error">
                            {errors.admin_name &&
                              touched.admin_name &&
                              errors.admin_name}
                          </p>
                        )}
                    </div>
                    <div>
                      <TextFieldInput
                        name="admin_email"
                        type="email"
                        placeholder={"Enter your email"}
                        className="Input"
                        label={"Admin Email"}
                        change={handleChange}
                        blur={handleBlur}
                        newValue={values.admin_email}
                      />
                      {errors.admin_email &&
                        touched.admin_email &&
                        errors.admin_email && (
                          <p className="error">
                            {errors.admin_email &&
                              touched.admin_email &&
                              errors.admin_email}
                          </p>
                        )}
                    </div>
                    <div>
                      <TextFieldInput
                        name="password"
                        type="password"
                        placeholder={"Enter a new password"}
                        className="Input"
                        label={"Create A New Password"}
                        change={handleChange}
                        blur={handleBlur}
                        newValue={values.password}
                      />
                      {errors.password &&
                        touched.password &&
                        errors.password && (
                          <p className="error">
                            {errors.password &&
                              touched.password &&
                              errors.password}
                          </p>
                        )}
                    </div>
                    <div>
                      <TextFieldInput
                        name="confirmPassword"
                        type="password"
                        placeholder={"Rewrite your password"}
                        className="Input"
                        label={"Confirm Your Password"}
                        change={handleChange}
                        blur={handleBlur}
                        newValue={values.confirmPassword}
                      />
                      {errors.confirmPassword &&
                        touched.confirmPassword &&
                        errors.confirmPassword && (
                          <p className="error">
                            {errors.confirmPassword &&
                              touched.confirmPassword &&
                              errors.confirmPassword}
                          </p>
                        )}
                    </div>
                    <div style={{ position: "relative" }}>
                      <label className="labelPhone">Admin Phone Number *</label>
                      <PhoneInput
                        label={"Enter Admin Phone Number"}
                        className="textfield Input phoneInput"
                        value={Phone}
                        defaultCountry="eg"
                        onChange={(e) => {
                          setPhone(e);
                        }}
                      />
                      {PhoneError && PhoneTouched ? (
                        <p className="error">{PhoneError}</p>
                      ) : (
                        ""
                      )}
                    </div>
                    <div>
                      <TextFieldInput
                        select
                        label="Where did you hear about us?"
                        newValue={values.referralSource}
                        placeholder={"Select an option or enter your answer..."}
                        name={"referralSource"}
                        change={handleChange}
                        blur={handleBlur}
                        fullWidth
                        className={`Input`}
                        variant="outlined"
                        SelectProps={{
                          displayEmpty: true,
                        }}
                      >
                        <MenuItem value="" className="" disabled>
                          Where did you hear about us?
                        </MenuItem>
                        {[
                          {
                            name: "Social Media (Facebook, Instagram, LinkedIn, etc.)",
                            value: "Social Media",
                          },
                          {
                            name: "Search Engine (Google, Bing, etc.)",
                            value: "Search Engine",
                          },
                          {
                            name: "Friend/Colleague Recommendation",
                            value: "Friend",
                          },
                          {
                            name: "Attended an Event or Workshop",
                            value: "Event",
                          },
                          {
                            name: "Advertisement (Online or Offline)",
                            value: "Advertisement",
                          },
                          {
                            name: "Other",
                            value: "Other",
                          },
                        ]?.map((item) => (
                          <MenuItem key={item?.value} value={item?.value}>
                            {item?.name}
                          </MenuItem>
                        ))}
                      </TextFieldInput>
                      {errors.referralSource &&
                        touched.referralSource &&
                        errors.referralSource && (
                          <p className="error">
                            {errors.referralSource &&
                              touched.referralSource &&
                              errors.referralSource}
                          </p>
                        )}
                    </div>

                    {/* {userType == "individual" ? (
                      <>
                        <div>
                          <TextFieldInput
                            select
                            label="Country"
                            newValue={values.country}
                            placeholder={"Choose country"}
                            name={"country"}
                            change={(newValue) => {
                              handleChange(newValue);
                              setCountry(newValue);
                              handleChange({
                                target: { name: "gov", value: "" },
                              });
                            }}
                            blur={handleBlur}
                            fullWidth
                            className={`Input`}
                            variant="outlined"
                            SelectProps={{
                              displayEmpty: true,
                            }}
                          >
                            <MenuItem value="" className="" disabled>
                              Choose Country
                            </MenuItem>
                            {countriesList?.map((item) => (
                              <MenuItem key={item?.id} value={item?.id}>
                                {item?.name}
                              </MenuItem>
                            ))}
                          </TextFieldInput>
                          {errors.country &&
                            touched.country &&
                            errors.country && (
                              <p className="error">
                                {errors.country &&
                                  touched.country &&
                                  errors.country}
                              </p>
                            )}
                        </div>
                        <div>
                          <TextFieldInput
                            select
                            label="Governorate"
                            newValue={values?.gov}
                            placeholder={"Choose governorate"}
                            name={"gov"}
                            change={handleChange}
                            blur={handleBlur}
                            fullWidth
                            className={`Input`}
                            variant="outlined"
                            SelectProps={{
                              displayEmpty: true,
                            }}
                          >
                            <MenuItem value="" className="" disabled>
                              Choose Governorate
                            </MenuItem>
                            {cities?.map((item) => (
                              <MenuItem key={item?.id} value={item?.id}>
                                {item?.name}
                              </MenuItem>
                            ))}
                          </TextFieldInput>
                          {errors.gov && touched.gov && errors.gov && (
                            <p className="error">
                              {errors.gov && touched.gov && errors.gov}
                            </p>
                          )}
                        </div>
                      </>
                    ) : (
                      ""
                    )} */}
                  </div>

                  {userType == "organization" ? (
                    <>
                      <h2>Organization Details:</h2>
                      <div className="FormContainerBox">
                        <div>
                          <TextFieldInput
                            select
                            label="Choose your organization"
                            newValue={values.organization_id}
                            placeholder={"Choose your organization"}
                            name={"organization_id"}
                            change={handleChange}
                            blur={handleBlur}
                            fullWidth
                            className={`Input`}
                            variant="outlined"
                            SelectProps={{
                              displayEmpty: true,
                            }}
                          >
                            <MenuItem value="" className="" disabled>
                              Choose your organization
                            </MenuItem>
                            {organizationsList?.map((item) => (
                              <MenuItem key={item?.id} value={item?.id}>
                                {item?.name}
                              </MenuItem>
                            ))}
                            <MenuItem value={-1} className="">
                              Other
                            </MenuItem>
                          </TextFieldInput>
                          {errors.organization_id &&
                            touched.organization_id &&
                            errors.organization_id && (
                              <p className="error">
                                {errors.organization_id &&
                                  touched.organization_id &&
                                  errors.organization_id}
                              </p>
                            )}
                        </div>
                        {values.organization_id == -1 ? (
                          <>
                            <div>
                              <TextFieldInput
                                name="organization_name"
                                type="text"
                                placeholder={"Enter organization name"}
                                className="Input"
                                label="Organization Name"
                                change={handleChange}
                                blur={handleBlur}
                                newValue={values.organization_name}
                              />
                              {errors.organization_name &&
                                touched.organization_name &&
                                errors.organization_name && (
                                  <p className="error">
                                    {errors.organization_name &&
                                      touched.organization_name &&
                                      errors.organization_name}
                                  </p>
                                )}
                            </div>
                          </>
                        ) : (
                          ""
                        )}
                        <div>
                          <TextFieldInput
                            select
                            label="Branch Country"
                            newValue={values.country}
                            placeholder={"Choose branch country"}
                            name={"country"}
                            change={(newValue) => {
                              handleChange(newValue);
                              setCountry(newValue);
                              console.log(newValue);
                            }}
                            blur={handleBlur}
                            fullWidth
                            className={`Input`}
                            variant="outlined"
                            SelectProps={{
                              displayEmpty: true,
                            }}
                          >
                            <MenuItem value="" className="" disabled>
                              Choose Branch Country
                            </MenuItem>
                            {countriesList?.map((item) => (
                              <MenuItem key={item?.id} value={item?.id}>
                                {item?.name}
                              </MenuItem>
                            ))}
                          </TextFieldInput>
                          {errors.country &&
                            touched.country &&
                            errors.country && (
                              <p className="error">
                                {errors.country &&
                                  touched.country &&
                                  errors.country}
                              </p>
                            )}
                        </div>
                        <div>
                          <TextFieldInput
                            select
                            label="Branch Governorate"
                            newValue={values.gov}
                            placeholder={"Choose Branch governorate"}
                            name={"gov"}
                            change={handleChange}
                            blur={handleBlur}
                            fullWidth
                            className={`Input`}
                            variant="outlined"
                            SelectProps={{
                              displayEmpty: true,
                            }}
                          >
                            <MenuItem value="" className="" disabled>
                              Choose Branch Governorate
                            </MenuItem>
                            {cities?.length
                              ? cities?.map((item) => (
                                  <MenuItem key={item?.id} value={item?.id}>
                                    {item?.name}
                                  </MenuItem>
                                ))
                              : ""}
                          </TextFieldInput>
                          {errors.gov && touched.gov && errors.gov && (
                            <p className="error">
                              {errors.gov && touched.gov && errors.gov}
                            </p>
                          )}
                        </div>
                        <div style={{ position: "relative" }}>
                          <label className="labelPhone">
                            Branch Phone Number*
                          </label>
                          <PhoneInput
                            label={"Enter Branch Phone Number"}
                            className="textfield Input phoneInput"
                            value={PhoneOrg}
                            defaultCountry="eg"
                            onChange={(e) => {
                              setPhoneOrg(e);
                            }}
                          />
                          {PhoneOrgError && PhoneOrgTouched ? (
                            <p className="error">{PhoneOrgError}</p>
                          ) : (
                            ""
                          )}
                        </div>
                        <div>
                          <TextFieldInput
                            name="address"
                            type="text"
                            placeholder={"Enter branch address"}
                            className="Input"
                            label="Branch Address"
                            change={handleChange}
                            blur={handleBlur}
                            newValue={values.address}
                          />
                          {errors.address &&
                            touched.address &&
                            errors.address && (
                              <p className="error">
                                {errors.address &&
                                  touched.address &&
                                  errors.address}
                              </p>
                            )}
                        </div>
                      </div>
                    </>
                  ) : (
                    ""
                  )}

                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      justifyContent: "center",
                      marginTop: "40px",
                    }}
                  >
                    <Button
                      variant="contained"
                      color="primary"
                      style={{ minWidth: "200px" }}
                      onClick={() => {
                        setPhoneTouched(true);
                        setPhoneOrgTouched(true);
                        handleSubmit();
                      }}
                    >
                      {addLoading ? (
                        <div className="loadingSmallBox">
                          <PulseLoader size={6} color="#fff" />
                        </div>
                      ) : (
                        "Submit"
                      )}
                    </Button>
                  </div>
                </form>
              )}
            </Formik>

            <WhiteModal
              open={confirmOpen}
              handleClose={() => {
                setConfirmOpen(false);
              }}
              Style={"modalBox"}
              inSide={
                <Box>
                  {console.log(newObjectConfirm)}
                  <h1 style={{ textAlign: "center", marginBottom: "5px" }}>
                    Application Review
                  </h1>
                  <p
                    style={{
                      textAlign: "center",
                      marginBottom: "30px",
                      marginTop: "5px",
                    }}
                  >
                    Please review all details carefully before submission
                  </p>
                  {userType != "organization" ? (
                    // <h3>1 - Admin:</h3>
                    <h3>Team Leader:</h3>
                  ) : (
                    ""
                  )}

                  <ul className="confirmList">
                    <li>
                      <span className="listTitle">Name:</span>{" "}
                      {newObjectConfirm?.account?.admin?.name}
                    </li>
                    <li>
                      <span className="listTitle">Email:</span>{" "}
                      {newObjectConfirm?.account?.admin?.email}
                    </li>
                    <li>
                      <span className="listTitle">Phone Number:</span>{" "}
                      {newObjectConfirm?.account?.admin?.contactNumber}
                    </li>
                    {newObjectConfirm?.account?.type == "personal" ? (
                      <>
                        <li>
                          <span className="listTitle">Country:</span>{" "}
                          {
                            newObjectConfirm?.account?.personalAccountInfo
                              ?.country
                          }
                        </li>
                        <li>
                          <span className="listTitle">Governate:</span>{" "}
                          {newObjectConfirm?.account?.personalAccountInfo?.city}
                        </li>
                      </>
                    ) : (
                      ""
                    )}
                  </ul>
                  {newObjectConfirm?.account?.type == "organization" ? (
                    <>
                      <h3>Organization Details:</h3>
                      <ul className="confirmList">
                        <li>
                          <span className="listTitle">Name:</span>{" "}
                          {newObjectConfirm?.account?.organization?.name}
                        </li>
                        <li>
                          <span className="listTitle">Phone Number:</span>{" "}
                          {
                            newObjectConfirm?.account?.organization?.branch
                              ?.contactNumber
                          }
                        </li>
                        <li>
                          <span className="listTitle">Country:</span>{" "}
                          {
                            newObjectConfirm?.account?.organization?.branch
                              ?.country
                          }
                        </li>
                        <li>
                          <span className="listTitle">Governate:</span>{" "}
                          {
                            newObjectConfirm?.account?.organization?.branch
                              ?.city
                          }
                        </li>
                        <li>
                          <span className="listTitle">Address:</span>{" "}
                          {
                            newObjectConfirm?.account?.organization?.branch
                              ?.address
                          }
                        </li>
                      </ul>
                    </>
                  ) : (
                    ""
                  )}

                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      justifyContent: "center",
                      margin: "10px 0",
                    }}
                  >
                    <Button
                      variant="contained"
                      color="primary"
                      style={{ minWidth: "150px", margin: "0 5px" }}
                      onClick={() => {
                        setFinalSave(true);
                      }}
                    >
                      {FinalLoading ? (
                        <div className="loadingSmallBox">
                          <PulseLoader size={6} color="#fff" />
                        </div>
                      ) : (
                        "Submit"
                      )}
                    </Button>
                    <Button
                      variant="contained"
                      color="primary"
                      style={{ minWidth: "150px", margin: "0 5px" }}
                      onClick={() => {
                        setConfirmOpen(false);
                      }}
                    >
                      Edit
                    </Button>
                  </div>
                </Box>
              }
            />
            <WhiteModal
              open={feesOpen}
              handleClose={() => {
                setFeesOpen(false);
              }}
              Style={"modalBox"}
              inSide={
                <>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "flex-end",
                      alignItems: "center",
                    }}
                  >
                    <CloseIcon
                      style={{ cursor: "pointer", marginTop: "5px" }}
                      onClick={() => {
                        setFeesOpen(false);
                      }}
                    />
                  </Box>
                  <h2 style={{ textAlign: "center", margin: "10px 5px 5px 0" }}>
                    International Robot Challenge
                  </h2>
                  <Box
                    sx={{
                      height: "3px",
                      width: "100%",
                      backgroundColor: "primary.main",
                      margin: "10px auto",
                    }}
                  />
                  <h3>Competition Categories:</h3>
                  <ul>
                    <li>Sumo Lego</li>
                    <li>Sumo Mega</li>
                    <li>Sumo Mini</li>
                    <li>Follow Line Lego</li>
                    <li>Follow line Open</li>
                    <li>Bowling</li>
                    <li>Buck Collector</li>
                    <li>Free Style</li>
                  </ul>
                  <h3>Team Rules:</h3>
                  <ul>
                    <li>All Categories:</li>
                    <ul>
                      <li>From 3 - 5 members guided by a teacher/coach</li>
                    </ul>
                    <li>Free Style Category:</li>
                    <ul>
                      <li>From 1 - 5 members guided by a teacher/coach </li>
                    </ul>
                  </ul>
                  {/* <h3>Registration Fees:</h3>
                  <ul>
                    <li>All Categories:</li>
                    <ul>
                      <li>4500 EGP for a team with 3 members</li>
                      <li>5500 EGP for a team with 4 members</li>
                      <li>6500 EGP for a team with 5 members</li>
                    </ul>
                    <li>Free Style Category:</li>
                    <ul>
                      <li>1250 EGP per student</li>
                    </ul>
                  </ul> */}
                  <h3>
                    The deadline of registration is{" "}
                    <span style={{ color: "red" }}>01 - 08 - 2024.</span>
                  </h3>
                </>
              }
            />
          </Box>
        </>
      )}
    </>
  );
};

export default FirstStageTemplate;
